<i18n>
{
  "fr": {
    "form-list-title": "Liste des contacts",
    "id-label": "N°",
    "companyname-label": "Nom de l'entreprise",
    "address-label": "Adresse",
    "zip-label": "Npa",
    "city-label": "Ville",
    "firstname-label": "Prénom",
    "lastname-label": "Nom",
    "phone-label": "Numéro de téléphone",
    "email-label": "Adresse email",
    "create-label": "Date de création",
    "last-update-label": "Dernière modification",
    "required-field": "Ce champs est requis",
    "must-be-swiss-phone-number-field": "Le format \"+41 21 123 45 56\" doit être respecté",
    "must-be-valid-email-field": "Cette adresse email n'est pas valide"
  },
  "de": {
    "form-list-title": "Kontaktverwaltung",
    "id-label": "Nr.",
    "companyname-label": "Firma",
    "address-label": "Adresse",
    "zip-label": "PLZ",
    "city-label": "Stadt",
    "firstname-label": "Vorname",
    "lastname-label": "Name",
    "phone-label": "Telefonnummer",
    "email-label": "E-Mail",
    "create-label": "Erstellungsdatum",
    "last-update-label": "Letzte Änderung",
    "required-field": "Dieses Feld wird benötigt",
    "must-be-swiss-phone-number-field": "Das \"+41 21 123 45 56\"-Format muss eingehalten werden",
    "must-be-valid-email-field": "Diese E-Mail-Adresse ist ungültig"
  }
}
</i18n>

<template>
  <div class="group-field">

    <div class="md-layout" v-if="show">
      <div v-if="showPostalAddress" class="md-layout-item md-medium-size-50 md-small-size-100">
        <md-field :class="getValidationClass('companyName')">
          <label>{{ $t('companyname-label') }}</label>
          <md-input v-model="contact.companyName" :required="isRequired('companyName')" :md-open-on-focus="true" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.companyName.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('address')">
          <label>{{ $t('address-label') }}</label>
          <md-input v-model="contact.address" :required="isRequired('address')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.address.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('zip')">
          <label>{{ $t('zip-label') }}</label>
          <md-input v-model="contact.zip" :required="isRequired('zip')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.zip.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('city')">
          <label>{{ $t('city-label') }}</label>
          <md-input v-model="contact.city" :required="isRequired('city')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.city.required">{{ $t('required-field') }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-medium-size-50 md-small-size-100">
        <md-field v-if="!showPostalAddress" :class="getValidationClass('companyName')">
          <label>{{ $t('companyname-label') }}</label>
          <md-input v-model="contact.companyName" :required="isRequired('companyName')" :md-open-on-focus="true" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.companyName.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('firstName')">
          <label>{{ $t('firstname-label') }}</label>
          <md-input v-model="contact.firstName" :required="isRequired('firstName')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.firstName.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('lastName')">
          <label>{{ $t('lastname-label') }}</label>
          <md-input v-model="contact.lastName" :required="isRequired('lastName')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.lastName.required">{{ $t('required-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('phone')">
          <label>{{ $t('phone-label') }}</label>
          <md-input v-model="contact.phone" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.phone.mustBeSwissPhoneNumber">{{ $t('must-be-swiss-phone-number-field') }}</span>
        </md-field>
        <md-field :class="getValidationClass('email')">
          <label>{{ $t('email-label') }}</label>
          <md-input v-model="contact.email" :required="isRequired('email')" :disabled="disabled"></md-input>
          <span class="md-error" v-if="!$v.contact.email.email">{{ $t('must-be-valid-email-field') }}</span>
          <span class="md-error" v-if="!$v.contact.email.required">{{ $t('required-field') }}</span>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import {
  required,
  email
} from 'vuelidate/lib/validators'
import {
  mustBeSwissPhoneNumber
} from '@/helpers/field-validators'

import Contact from '@/models/default/Contact'

const defaultValidationRules = {
  companyName: {
    required
  },
  address: {
    required
  },
  zip: {
    required
  },
  city: {
    required
  },
  firstName: {
    required
  },
  lastName: {
    required
  },
  phone: {
    mustBeSwissPhoneNumber
  },
  email: {
    email,
    required
  }
}

export default {
  name: 'ContactForm',
  mixins: [validationMixin],
  props: {
    contact: {
      type: Object,
      default: () => { return new Contact() }
    },
    contacts: {
      type: Array,
      default: () => { return [] }
    },
    disabled: {
      type: Boolean,
      default: () => { return false }
    },
    validations: {
      type: Object,
      default: () => { return _.clone(defaultValidationRules) }
    },
    show: {
      type: Boolean,
      default: () => { return true }
    },
    showPostalAddress: {
      type: Boolean,
      default: () => { return true }
    }
  },
  event: 'change',
  data () {
    return {
      contactJustBeSelected: null
    }
  },
  validations () {
    let toReturn = {}
    _.forOwn(defaultValidationRules, (value, key) => {
      if (key in this.validations) {
        toReturn[key] = this.validations[key]
      } else {
        toReturn[key] = value
      }
    })

    return {
      contact: toReturn
    }
  },
  watch: {
    contact: {
      handler (val) {
        if (this.contactJustBeSelected === null) {
          // SD Hack hack. A l'init, le parent nous envoie les données qu'il dispose.
          // Il ne faut pas prendre en compte cette event
          this.contactJustBeSelected = 1
          return
        }

        if (this.contactJustBeSelected < 2) {
          // SD Hacky hack. On essaie de modifier un contact existant.
          // Dans ce cas, on met l'ID à 0 pour recréer un nouveau contact.
          this.contact.id = 0
        }
      },
      deep: true
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.contact[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    isRequired (fieldName) {
      return typeof this.$v.contact[fieldName].required !== 'undefined'
    },
    filtredContacts () {
      return new Promise((resolve, reject) => {
        let searchTerm = this.contact.companyName
        if (!searchTerm) {
          resolve(this.contacts)
        } else {
          resolve(this.contacts.filter((contact) => {
            return contact.companyName.toLowerCase().includes(searchTerm.toLowerCase())
          }))
        }
      })
    },
    onContactSelected (selectedContact) {
      selectedContact = typeof selectedContact === 'undefined' ? new Contact() : selectedContact

      // SD Hacky hack. Permet de remettre à zero le formulaire si le nom de l'entreprise à changé.
      this.contactJustBeSelected = 2
      // this.$emit('change', _.clone(selectedContact))
    },
    onContactChanged (searchTerm) {
      if (--this.contactJustBeSelected === 0) {
        // Lorsqu'un contact est sélectionné, cette méthode est apellée 2 fois car :
        // - On a cliqué sur un contact de la liste
        // - Tous les champs du formulaire sont remplacé à la sélection du contact par le parent (emit change)
        // Donc: this.contactJustBeSelected est un compteur définit à 2 lors de la sélection et qui décrément a chaque fois que la méthode est appelée ...
        // Ce qui permet d'éviter d'effectuer le code ci-dessous lors de la selection du contact
        // Hacky Hack...
        let toEmit = new Contact()
        this.$emit('change', toEmit)
        this.contactJustBeSelected = 0
      }

      if (searchTerm === '') {
        let toEmit = new Contact()
        this.$emit('change', toEmit)
      }
    }
  }
}
</script>

<style lang="scss">
.md-autocomplete-items {
  .md-list-item-content {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

<style lang="scss" scoped>
.group-field {
  padding: 20px;
}

.md-layout-item {
  padding: 10px;
}

.map {
  width: 100%;
  height:400px;
}

.md-autocomplete-items {
  .md-list-item-content {

    .md-highlight-text {
      width: 100%;
    }
    .email-info {
      width: 100%;
      font-size: 11px;
      color: grey;
    }
  }
}
</style>
